import { makeAspectCrop, centerCrop, convertToPixelCrop } from "react-image-crop";

const convertPixelToPercentage = (pixel, total) => (pixel / total) * 100;

// Center a fixed-size crop within image
const centerFixedCrop = (mediaWidth, mediaHeight, targetWidth, targetHeight) => {
  const aspect = targetWidth / targetHeight;
  const cropWidthPercent = convertPixelToPercentage(targetWidth, mediaWidth);
  const crop = makeAspectCrop(
    { unit: "%", width: cropWidthPercent },
    aspect,
    mediaWidth,
    mediaHeight
  );
  return centerCrop(crop, mediaWidth, mediaHeight);
};

// Convert crop to blob (cropped image)
const getCroppedImage = (image, crop, fileName = "cropped.jpg") => {
  const canvas = document.createElement("canvas");
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;
  const pixelCrop = convertToPixelCrop(crop, image.width, image.height);

  canvas.width = pixelCrop.width * scaleX;
  canvas.height = pixelCrop.height * scaleY;

  const ctx = canvas.getContext("2d");
  ctx.drawImage(
    image,
    pixelCrop.x * scaleX,
    pixelCrop.y * scaleY,
    pixelCrop.width * scaleX,
    pixelCrop.height * scaleY,
    0,
    0,
    pixelCrop.width * scaleX,
    pixelCrop.height * scaleY
  );

  return new Promise((resolve) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) return;
        const url = URL.createObjectURL(blob);
        const file = new File([blob], fileName, { type: blob.type });
        resolve({ blob, url, file });
      },
      "image/jpeg",
      0.95
    );
  });
};

// ✅ Allow movement + resizing freely, but limit max size to `dimensions.width/height`
const handleCropChange = ({ newCrop, dimensions, image }) => {
    if (!image) return newCrop;
  
    // Actual rendered size in the browser
    const displayWidth = image.width;
    const displayHeight = image.height;
  
    // Your target limits
    const minWidth = Math.min(dimensions?.width, displayWidth);
    const minHeight = Math.min(dimensions?.height, displayHeight);
    const maxWidth = Math.min(dimensions?.width, displayWidth);
    const maxHeight = Math.min(dimensions?.height, displayHeight);
  
    // Convert new crop (in %) to pixels using display size
    const cropPx = convertToPixelCrop(newCrop, displayWidth, displayHeight);
  
    // Enforce min/max crop size
    let widthPx = Math.min(Math.max(cropPx.width, minWidth), maxWidth);
    let heightPx = Math.min(Math.max(cropPx.height, minHeight), maxHeight);
  
    // Keep crop fully inside visible image area
    let xPx = Math.min(Math.max(cropPx.x, 0), displayWidth - widthPx);
    let yPx = Math.min(Math.max(cropPx.y, 0), displayHeight - heightPx);
  
    // Convert back to % for ReactCrop
    return {
      unit: "%",
      x: (xPx / displayWidth) * 100,
      y: (yPx / displayHeight) * 100
    };
  };

export { centerFixedCrop, getCroppedImage, convertPixelToPercentage, handleCropChange };
